import moment from 'moment';

import { TimeCard } from '~/data/worktime';

export const momentIsFilled = (todaysTimeCard?: TimeCard): boolean => {
  if (todaysTimeCard) {
    const now = moment().format('HH:mm');
    return todaysTimeCard.timeBlocks.some(({ from, to }) => {
      if (from && moment(from, 'HH:mm:ss').format('HH:mm') <= now) {
        return !to || moment(to, 'HH:mm:ss').format('HH:mm') > now;
      }

      return false;
    });
  }

  return false;
};
